/*
  Wishlist click guard.

  The bespoke cards (works, explore works, recently viewed, artist collection)
  wrap their whole body in a product link, so a heart sitting over the image is
  inside that anchor. Without this, tapping the heart would also navigate to the
  product.

  Runs in the capture phase and only cancels the default action, so the Wishlist
  King / Swish handler on the button still receives the click.
*/
document.addEventListener(
  'click',
  (event) => {
    const target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    const button = target.closest('[data-js-wishlist-button]');
    if (!button) return;
    if (!button.closest('a')) return;

    event.preventDefault();
  },
  true,
);
